// extracted by css-extract-rspack-plugin
var _1 = "QiYB7t3NeDoLHfLE";
var _2 = "uf0Cpl_MHAQ31LG5";
var _3 = "uf0Cpl_MHAQ31LG5";
var _4 = "EF79L2LPqYYDa5cw";
var _5 = "CJNgY5oLZ46LX4D0";
var _6 = "CJNgY5oLZ46LX4D0";
var _7 = "QuVlmpcBnUML7_gC";
export { _1 as "label", _2 as "menu-item", _3 as "menuItem", _4 as "name", _5 as "trigger-wrapper", _6 as "triggerWrapper", _7 as "wrapper" }
